import React from 'react';
import Accordion from '../../core/Accordion';
import { useTranslation } from 'react-i18next';

const accordionData = [
  {
    title: 'Wat kan je op ScConnect?',
    content:
      'ScConnect is een platform voor thuismentoren van School’s cool Amsterdam. Op ScConnect kan je jouw ervaringen met de begeleiding delen, tips en kennis uitwisselen en e-learning cursussen volgen. Maak contact met andere thuismentoren door met elkaar te chatten, en blijf op de hoogte van evenementen, workshops en intervisiebijeenkomsten van School’s cool. ',
  },
  {
    title: 'Wat zijn de huisregels van ScConnect? ',
    content: `
    Op dit platform delen thuismentoren persoonlijke verhalen, tips en informatie over het mentorschap en de begeleiding van hun leerling. Hierbij gelden een paar voorschriften:\n
      Houd leerlingen anoniem, door de gegevens van jouw leerling niet te benoemen zoals de achternaam en adresinformatie van jouw leerling. Gebruik alleen de voornaam van jouw leerling in berichten en reacties.',
      Deel geen foto’s op het platform waarop jouw leerling herkenbaar in beeld is te zien. 
      Bespreek alleen onderwerpen die gerelateerd zijn aan de topics. Missen er topics? Laat het ons dan weten.
  `,
  },
  {
    title: 'Hoe kan ik deelnemen aan een evenement? ',
    content:
      'Op de pagina Evenementen worden alle evenementen getoond. Klik op een evenement waar je in geïnteresseerd bent en druk op de knop deelnemen. Zo blijf je op de hoogte van alle informatie over het evenement.',
  },
  {
    title: 'Hoe kan ik chatten met andere mentoren?',
    content:
      'Rechtsonder op de pagina van ScConnect is een chat-icoon zichtbaar. Klik op het icoon en stuur een bericht naar een andere thuismentor.',
  },
  {
    title: 'Wat zijn topics? ',
    content:
      'Topics zijn verschillende onderwerpen, waar thuismentoren informatie en ervaringen over kunnen delen.',
  },
  {
    title: 'Hoe kan ik een bericht plaatsen? ',
    content:
      'Kies een topic waar je een bericht bij wil plaatsen op de pagina Topics. Schrijf een bericht en druk op plaats bericht om het bericht te plaatsen onder de topic naar keuze.',
  },
  {
    title: 'Hoe kan ik iemand volgen?',
    content:
      'Op de startpagina is rechts een blok met Leden te zien. Naast de namen van de leden staat een plus-icoon. Om iemand te volgen klik je op de plus. Op de startpagina kan je kiezen om de berichten van iedereen te zien (alles), of alleen van de mensen die je volgt (volgend).',
  },
  {
    title: 'Hoe kom ik in contact met School’s cool Amsterdam? ',
    content:
      'Mocht je een opmerking of verzoek hebben voor School’s cool over het platform, stuur dan een chatbericht via ScConnect of e-mail naar info@schoolscoolamsterdam.nl.  ',
  },
];

function FaqMainContent() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4 mt-8">
      <div className="flex flex-col">
        <h1 className="font-bold text-grey-dark text-xl">
          {t('frequently_asked_questions')}
        </h1>
      </div>
      <ul>
        {accordionData.map(({ title, content }) => (
          <Accordion title={title} content={content} key={title} />
        ))}
      </ul>
    </div>
  );
}

export default FaqMainContent;
